import { render } from "./NewCustomerModal.vue?vue&type=template&id=2b713fff&scoped=true"
import script from "./NewCustomerModal.vue?vue&type=script&lang=js"
export * from "./NewCustomerModal.vue?vue&type=script&lang=js"

import "./NewCustomerModal.vue?vue&type=style&index=0&id=2b713fff&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b713fff"]])

export default __exports__